var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 50,
    height: 35,
    rx: 3.5,
    fill: "#FBFCFF",
    stroke: "#D5E3ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Visa_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.774 12c-2.483 0-4.701 1.246-4.701 3.547 0 2.64 3.934 2.821 3.934 4.147 0 .559-.66 1.058-1.79 1.058-1.601 0-2.799-.698-2.799-.698l-.512 2.322s1.38.59 3.21.59c2.715 0 4.85-1.307 4.85-3.647 0-2.79-3.95-2.966-3.95-4.197 0-.437.542-.916 1.668-.916a5.82 5.82 0 0 1 2.306.508l.501-2.243S31.364 12 29.774 12Zm-22.714.17-.06.338s1.044.185 1.985.554c1.211.423 1.298.67 1.502 1.435l2.223 8.295h2.98l4.59-10.623h-2.973l-2.95 7.222-1.203-6.121c-.11-.701-.67-1.1-1.354-1.1H7.06Zm14.415 0-2.332 10.622h2.835l2.324-10.623h-2.827Zm15.812 0c-.684 0-1.046.354-1.312.973l-4.153 9.649h2.973l.575-1.609h3.622l.35 1.609h2.623l-2.289-10.623h-2.389Zm.387 2.87.88 3.985h-2.36l1.48-3.986Z",
    fill: "#1434CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Visa_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 12)",
    d: "M0 0h35v11H0z"
  })))));
};

export default SvgVisa;